import { Dialog, IconButton, MenuItem } from '@mui/material';
import * as Styles from './SettingsModal.styles';
import React, { FC } from 'react';
import { Cancel } from '@mui/icons-material';
import { useLanguage } from 'context/AppContext';
import locale, { Locales } from 'locale/locale';
import DropDown from 'components/DropDown/DropDown';

interface SettingsModalProps {
  open: boolean;
  close: () => void;
}

const emojiMap: { [key in Locales]: string } = {
  English: 'au',
  Japanese: 'jp',
};

const SettingsModal: FC<SettingsModalProps> = ({ open, close }) => {
  const [language, dispatchLanguage, storedLocale] = useLanguage();

  return (
    <Dialog open={open} onClose={close} maxWidth="md">
      <Styles.Container>
        <IconButton sx={{ position: 'absolute !important', top: '1rem', right: '1rem' }} onClick={close}>
          <Cancel />
        </IconButton>
        <h2>{language.SettingsModal.language}</h2>
        <DropDown
          id="language"
          value={storedLocale}
          fullWidth
          variant="outlined"
          onChange={e => dispatchLanguage(e.target.value as Locales)}
        >
          {Object.keys(locale).map(localeKey => (
            <MenuItem key={localeKey} value={localeKey}>
              <Styles.Flag code={emojiMap[localeKey as Locales]} height="14" />
              {localeKey}
            </MenuItem>
          ))}
        </DropDown>
      </Styles.Container>
    </Dialog>
  );
};

export default SettingsModal;
